<template>
  <v-dialog
    v-model="dialog"
    @keydown.esc="closeDialog"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-tabs v-model="tabCampaign" centered>
        <v-tab
          v-for="item in itemsTabCampaign"
          :id="item"
          :key="item"
          class="font-size-sub"
          v-on:click="tabClick(item)"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-card-text>
        <v-container>
          <v-row v-if="currentTabCampaign === 'Campaign'">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                id="name"
                v-model="editedItem.name"
                label="Campaign name"
                hide-details
                dense
                :rules="[
                  rules.rulesCharcacters50.required,
                  rules.rulesCharcacters50.min,
                  rules.rulesCharcacters50.max
                ]"
                v-on:blur="editedItem.name = editedItem.name.trim()"
                @change="errorMessage.text = ''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex">
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="width100" v-bind="attrs" v-on="on" multiple>
                    <v-select
                      v-model="editedItem.flowId"
                      label="Flow"
                      :items="flows"
                      item-value="_id"
                      item-text="name"
                      hide-details
                    ></v-select>
                  </div>
                </template>
                <span>The flow to use for this campaign</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="m-l-10"
                    :disabled="!editedItem.flowId"
                    @click="goToFlow(editedItem.flowId)"
                  >
                    fa-arrow-up-right-from-square
                  </v-icon>
                </template>
                <span>Open flow</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex">
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="width100" v-bind="attrs" v-on="on" multiple>
                    <v-combobox
                      v-model="editedItem.fieldGroup"
                      :items="groups"
                      label="Field group (shown in campaign result)"
                      hide-details
                      @keyup="enterItem"
                    ></v-combobox>
                  </div>
                </template>
                <span>
                  When downloading campaign result, all fields in this group
                  will be exported in the CSV.<br /><br />
                  If field group is changed, try downloading campaign result
                  again to get the updated results.</span
                >
              </v-tooltip>
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="m-l-10"
                    @click="goToField"
                  >
                    fa-arrow-up-right-from-square
                  </v-icon>
                </template>
                <span>Open Fields</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-textarea
                id="description"
                class="textarea-input"
                v-model="editedItem.detail"
                label="Description"
                rows="4"
                solo
                hide-details
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-switch
                id="is_enable"
                v-model="editedItem.isEnable"
                :label="editedItem.isEnable ? 'Enabled' : 'Disabled'"
                v-on:change="changeEnable"
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row v-if="currentTabCampaign === 'Call settings'">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <div style="font-size: 11px" v-bind="attrs" v-on="on">
                    Priority order (0 = lowest, 100 = highest)
                  </div>
                </template>
                <span>
                  When there are multiple active campaigns, the one with the
                  highest priority will be called first
                </span>
              </v-tooltip>
              <div class="d-flex align-center justify-start">
                <v-slider
                  id="priority-order"
                  v-model="editedItem.priorityOrder"
                  min="0"
                  max="100"
                  :thumb-size="24"
                  hide-details
                  class="slider-scroll"
                ></v-slider>
                <span class="slider-text m-l-5">
                  {{ editedItem.priorityOrder.toString() }}
                </span>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="width100" v-bind="attrs" v-on="on" multiple>
                    <v-text-field
                      id="max-concurrent"
                      type="number"
                      v-model="editedItem.maxConcurrent"
                      label="Max concurrents"
                      min="0"
                      dense
                      hide-details
                      v-on:blur="minZeroBlur('maxConcurrent')"
                    ></v-text-field>
                  </div>
                </template>
                <span>
                  Maximum number of concurrents allocated to this campaign. This
                  number can not be higher than the number of licenses
                  available.
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="width100" v-bind="attrs" v-on="on" multiple>
                    <v-text-field
                      id="ringing-timeout"
                      type="number"
                      v-model="editedItem.ringingTimeout"
                      label="Ringing timeout (seconds)"
                      min="0"
                      dense
                      hide-details
                      v-on:blur="minZeroBlur('ringingTimeout')"
                    ></v-text-field>
                  </div>
                </template>
                <span>
                  If the callee does not answer within the specified period, the
                  call will be marked as noanswer
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="width100" v-bind="attrs" v-on="on" multiple>
                    <v-text-field
                      id="retry-count"
                      type="number"
                      v-model="editedItem.retryCount"
                      label="Max attempts (1 = no retry)"
                      min="1"
                      dense
                      hide-details
                      v-on:blur="minZeroBlur('retryCount')"
                    >
                    </v-text-field>
                  </div>
                </template>
                <span>
                  How many attempts bot should retry if the call is not answered
                  (i.e. status is busy or noanswer)
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-tooltip :max-width="350" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="width100" v-bind="attrs" v-on="on" multiple>
                    <v-text-field
                      id="retry-interval"
                      type="number"
                      v-model="editedItem.retryInterval"
                      label="Retry interval (minutes)"
                      min="0"
                      :disabled="checkRetryCount"
                      dense
                      hide-details
                      v-on:blur="minZeroBlur('retryInterval')"
                    ></v-text-field>
                  </div>
                </template>
                <span>
                  How long bot should wait before retrying that number
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-switch
                v-model="editedItem.retryWithPriority"
                inset
                dense
                hide-details
                :disabled="checkRetryCount"
              >
                <template slot="label">
                  <v-tooltip :max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">Priority retry</div>
                    </template>
                    <span>Pick retry leads before new leads</span>
                  </v-tooltip>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-switch v-model="editedItem.mergeCall" inset dense hide-details>
                <template slot="label">
                  <v-tooltip :max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Merge records of same phone number into a single call
                      </div>
                    </template>
                    <span
                      >If there are multiple leads with same phone number, those
                      records will be merged into one single call</span
                    >
                  </v-tooltip>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-switch
                v-model="editedItem.preCallApi"
                inset
                dense
                hide-details
              >
                <template slot="label">
                  <v-tooltip :max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">Pre-call API</div>
                    </template>
                    <span>
                      Make an API request before calling. This can be used to
                      check correctness of payload; or check with backend
                      systems whether a call is still necessary at the time of
                      calling e.g. bot should not make a reminder call if the
                      callee recently made payment.
                    </span>
                  </v-tooltip>
                </template>
              </v-switch>
            </v-col>
            <v-col
              v-if="editedItem.preCallApi"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dialog-api
                :editedItem="editedItem"
                functionName="preCallApi"
                description="Successful API will progress to phone call. Failed API will be marked as skipped.\nPayload can be referenced via ${system.payload.*}"
              ></dialog-api>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" class="pb-0">
              <v-switch
                v-model="editedItem.isCustomCaller"
                inset
                dense
                hide-details
              >
                <template slot="label">
                  <v-tooltip :max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Custom Caller ID (A Number)
                      </div>
                    </template>
                    <span>
                      Select Caller ID to show when users answer the calls. You
                      need to own these numbers and they must be first
                      configured on Advanced settings | Telephony settings.
                    </span>
                  </v-tooltip>
                </template>
              </v-switch>
            </v-col>
            <v-col
              v-if="editedItem.isCustomCaller"
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="pt-0"
            >
              <v-select
                v-model="editedItem.customCallerArr"
                :items="callers"
                class="m-l-55"
                dense
                hide-details
                multiple
                chips
                clearable
                clear-icon="fa-times"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="currentTabCampaign === 'Schedule'">
            <v-col cols="12" sm="6" md="6" lg="6">
              <VueCtkDateTimePicker
                v-model="editedItem.startDate"
                :max-date="editedItem.endDate"
                :format="$dateFormatDefault"
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                onlyDate
              >
                <v-text-field
                  class="font-size-body"
                  v-model="dateFrom"
                  prepend-inner-icon="mdi-calendar small"
                  label="From"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </VueCtkDateTimePicker>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <VueCtkDateTimePicker
                v-model="editedItem.endDate"
                :min-date="editedItem.startDate"
                :format="$dateFormatDefault"
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                onlyDate
              >
                <v-text-field
                  class="font-size-body"
                  v-model="dateTo"
                  prepend-inner-icon="mdi-calendar small"
                  label="To"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </VueCtkDateTimePicker>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-b-5">
              <div class="time1"></div>
              <div class="time2 font-size-sub">00:00</div>
              <div class="time3 font-size-sub">06:00</div>
              <div class="time4 font-size-sub">12:00</div>
              <div class="time5 font-size-sub">18:00</div>
              <div class="time6 font-size-sub text-right">00:00</div>
            </v-col>

            <div v-for="(time, index) in editedItem.times" :key="index">
              <div class="p-r-12 p-l-12">
                <div class="d-flex p-b-12">
                  <div class="day1">{{ time.text }}</div>

                  <div
                    v-if="
                      time.data.length === 0 ||
                        time.error.time ||
                        time.error.overlap
                    "
                    class="time-inactive cursor-pointer"
                    style="width: 410.25px"
                    @click="expandTimeClick(index)"
                  ></div>
                  <div
                    v-else
                    class="d-flex cursor-pointer"
                    @click="expandTimeClick(index)"
                  >
                    <div
                      v-for="(data, index1) in time.data"
                      class="d-flex"
                      :key="index1"
                    >
                      <div
                        v-if="index1 === 0 && data.start !== 0"
                        class="time-inactive"
                        :style="`width: ${(data.start - 1) / 3.5}px`"
                      ></div>
                      <div
                        v-if="index1 !== 0"
                        class="time-inactive"
                        :style="
                          `width: ${(data.start -
                            (time.data[index1 - 1].end + 1)) /
                            3.5}px`
                        "
                      ></div>
                      <div
                        v-if="index1 === time.data.length - 1 && data.end === 0"
                        class="time-active"
                        :style="`width: ${(1440 - data.start) / 3.5}px`"
                      ></div>
                      <div
                        v-else
                        class="time-active"
                        :style="`width: ${(data.end - data.start) / 3.5}px`"
                      ></div>
                      <div
                        v-if="index1 === time.data.length - 1 && data.end !== 0"
                        class="time-inactive"
                        :style="`width: ${(1440 - (data.end + 1)) / 3.5}px`"
                      ></div>
                    </div>
                  </div>

                  <div class="day1 text-right">
                    <v-icon small @click="addTimeClick(index)">
                      fa-plus-circle
                    </v-icon>
                  </div>
                </div>

                <div v-if="time.is_expand">
                  <v-row
                    v-for="(data, index1) in time.data"
                    class="p-b-12"
                    :key="index1"
                  >
                    <v-col cols="12" sm="2" md="2" lg="2"> </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4">
                      <v-text-field
                        class="font-size-body"
                        :value="data.start | minToHour"
                        type="time"
                        label="From"
                        hide-details
                        dense
                        @change="timeChange"
                        @click="timeClick"
                        data-key="start"
                        :data-index="index"
                        :data-index1="index1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4">
                      <v-text-field
                        class="font-size-body"
                        :value="data.end | minToHour"
                        type="time"
                        label="To"
                        hide-details
                        dense
                        @change="timeChange"
                        @click="timeClick"
                        data-key="end"
                        :data-index="index"
                        :data-index1="index1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" lg="2" class="m-tb-auto">
                      <v-icon small @click="deleteTimeClick(index, index1)">
                        fa-times-circle
                      </v-icon>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <v-row v-if="time.error.time">
                <v-col cols="12" sm="2" md="2" lg="2"> </v-col>
                <v-col cols="12" sm="8" md="8" lg="8">
                  <div
                    :id="`error-time-${time.text}`"
                    class="text-center red--text"
                  >
                    Unable to save these response hours. Please make sure none
                    of your work periods overlap.
                  </div>
                </v-col>
                <v-col cols="12" sm="2" md="2" lg="2"> </v-col>
              </v-row>
              <v-row v-if="!time.error.time && time.error.overlap">
                <v-col cols="12" sm="2" md="2" lg="2"> </v-col>
                <v-col cols="12" sm="8" md="8" lg="8">
                  <div
                    :id="`error-overlap-${time.text}`"
                    class="text-center red--text"
                  >
                    Schedules must not overlap
                  </div>
                </v-col>
                <v-col cols="12" sm="2" md="2" lg="2"> </v-col>
              </v-row>
            </div>

            <v-col cols="12" sm="12" md="12" lg="12">
              <div class="d-flex">
                <v-switch
                  id="status"
                  v-model="editedItem.runOnHoliday"
                  :label="
                    editedItem.runOnHoliday
                      ? 'Allow calls on holidays'
                      : 'Do not call on holidays'
                  "
                  inset
                  dense
                  hide-details
                ></v-switch>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="m-l-10"
                      @click="goToHoliday"
                    >
                      fa-arrow-up-right-from-square
                    </v-icon>
                  </template>
                  <span>Open Holidays</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="currentTabCampaign === 'Payload'">
            <v-col cols="12" sm="12" md="12" lg="12" class="m-b-15">
              <div>
                Campaign's default payloads are automatically attached when
                adding new leads.<br />
                If default payloads and custom payloads have same name, custom
                payload prevails.<br /><br />
                Flow can reference to payload via ${system.payload.*}
              </div>
            </v-col>
            <v-col
              v-for="(item, index) in editedItem.payload"
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="p-t-0"
              :key="index"
            >
              <div class="d-flex">
                <v-text-field
                  :id="`payload-key-${index}`"
                  type="text"
                  v-model="item.key"
                  label="Key"
                  placeholder="Key"
                  dense
                  hide-details
                  @click="payloadKeyClick"
                  @change="payloadKeyChange"
                  :data-index="index"
                ></v-text-field>
                <v-text-field
                  :id="`payload-value-${index}`"
                  class="p-l-20 p-r-20"
                  type="text"
                  v-model="item.value"
                  label="Value"
                  placeholder="Value"
                  dense
                  hide-details
                ></v-text-field>
                <v-icon
                  :id="`delete-payload-${index}`"
                  small
                  right
                  @click="deletePayloadClick(index)"
                >
                  fa-times-circle
                </v-icon>
              </div>

              <div
                v-if="item.error.status"
                :id="`error-payload-key-${index}`"
                class="width100 text-center red--text m-t-5"
              >
                {{ `${item.error.text} already exists` }}
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0">
              <div id="icon-add-payload" @click="addPayloadClick">
                <v-icon class="margin0 p-r-10" small right>
                  fa-plus-circle
                </v-icon>
                Add payload
              </div>
            </v-col>
          </v-row>
          <v-row v-if="currentTabCampaign === 'Events'">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-switch
                v-model="editedItem.postCallApi"
                inset
                dense
                hide-details
              >
                <template slot="label">
                  <v-tooltip :max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Not answered after max attempts
                      </div>
                    </template>
                    <span>
                      Make an API call when the lead does not answer after max
                      attempts
                    </span>
                  </v-tooltip>
                </template>
              </v-switch>
            </v-col>
            <v-col
              v-if="editedItem.postCallApi"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dialog-api
                :editedItem="editedItem.postCallApiData"
                functionName="postCallApi"
                description="Make an API call when the lead does not answer after max attempts. This can be used as follow-up SMS, email, or to trigger another system of failed attempt.\nPayload can be referenced via ${system.payload.*}"
              ></dialog-api>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <div id="error" class="text-center red--text">
        {{ errorMessage.text }}
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-close" class="btn-secondary" @click="closeDialog">
          Cancel
        </v-btn>
        <v-btn id="btn-ok" class="btn-primary" @click="save">
          {{ btnSave }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiFlow from '@/apis/flow'
import apiField from '@/apis/field'
import apiSetting from '@/apis/setting'

import DialogApi from './dialog_api'

export default {
  name: 'DialogManageCampaignVoice',
  components: {
    DialogApi
  },
  props: {
    rules: Object,
    dialog: Boolean,
    action: String,
    editedItem: Object,
    errorMessage: Object,
    snackbar: Object
  },
  data() {
    return {
      tabCampaign: null,
      currentTabCampaign: 'Campaign',
      itemsTabCampaign: [
        'Campaign',
        'Call settings',
        'Schedule',
        'Payload',
        'Events'
      ],

      // Info
      checkRetryCount: true,

      // Schedule
      time: {
        key: '',
        index: '',
        index1: ''
      },
      groups: [],
      flows: [],
      callers: [],
      indexPayload: {
        index: ''
      },
      errorPayload: {
        status: false,
        text: ''
      }
    }
  },
  created() {
    this.editedItem.retryCount += 1
    this.checkRetryCount = this.editedItem.retryCount <= 1 ? true : false

    this.getGroup()
    this.getFlow('voice')
    this.getCustomCaller()
  },
  computed: {
    formTitle() {
      let text = ''

      switch (this.action) {
        case 'add':
          text = 'New campaign'
          break
        case 'edit':
          text = 'Edit campaign'
          break
        case 'clone':
          text = 'Clone campaign'
          break
        default:
        // code block
      }

      return text
    },
    btnSave() {
      let text = ''

      switch (this.action) {
        case 'add':
          text = 'Add'
          break
        case 'edit':
          text = 'Save'
          break
        case 'clone':
          text = 'Clone'
          break
        default:
        // code block
      }

      return text
    },
    dateFrom() {
      return this.$options.filters.convertDatePicker(this.editedItem.startDate)
    },
    dateTo() {
      return this.$options.filters.convertDatePicker(this.editedItem.endDate)
    }
  },
  methods: {
    changeEnable() {
      if (this.editedItem.isEnable) {
        if (!this.editedItem.flowId) {
          this.errorMessage.text =
            'Flow is not set. Assign a flow to campaign and try again.'

          setTimeout(() => {
            document.getElementById('is_enable').click()
          }, 500)
        }
      }
    },
    async getGroup() {
      try {
        const getGroup = await apiField.getGroup()
        const { data } = getGroup
        this.groups = data
      } catch (error) {}
    },
    async getFlow(platform) {
      try {
        const flows = await apiFlow.listFlowUiByPlatform(platform)
        this.flows = flows.data
      } catch {}
    },
    async getCustomCaller() {
      try {
        const callers = await apiSetting.getCustomCaller()
        this.callers = callers.data.custom_caller
      } catch {}
    },
    enterItem(e) {
      this.editedItem.fieldGroup = e.target.value
    },
    async tabClick(item) {
      this.currentTabCampaign = item

      if (item === 'Phone list') {
        await this.getCampaignLog()
      }
    },

    // Info
    minZeroBlur(text) {
      let minValue = 0
      if (text === 'retryCount') {
        minValue = 1
      }

      if (!this.editedItem[text] || this.editedItem[text] < minValue) {
        this.editedItem[text] = minValue
      }

      if (
        isNaN(parseInt(this.editedItem[text])) ||
        parseInt(this.editedItem[text]) < minValue
      ) {
        this.editedItem[text] = minValue
      } else {
        this.editedItem[text] = parseInt(this.editedItem[text])
      }

      if (text === 'retryCount') {
        this.checkRetryCount = this.editedItem[text] <= minValue ? true : false
      }
    },

    // Schedule
    expandTimeClick(index) {
      this.editedItem.times[index].is_expand = !this.editedItem.times[index]
        .is_expand
    },
    addTimeClick(index) {
      this.editedItem.times[index].is_expand = true

      const index1 = this.editedItem.times[index].data.length - 1

      let start = 540
      let end = 1080
      if (index1 !== -1) {
        start = this.editedItem.times[index].data[index1].end + 1
        end = this.editedItem.times[index].data[index1].end + 2
      }

      if (end <= 1440) {
        this.editedItem.times[index].data.push({
          start,
          end,
          is_error_time: false,
          is_error_overlap: false
        })
      }
    },
    async deleteTimeClick(index, index1) {
      this.editedItem.times[index].data.splice(index1, 1)

      await this.checkTime(index)
    },
    timeClick(event) {
      this.time.key = event.target.getAttribute('data-key')
      this.time.index = event.target.getAttribute('data-index')
      this.time.index1 = parseInt(event.target.getAttribute('data-index1'))
    },
    async timeChange(value) {
      this.errorMessage.text = ''

      const { key, index, index1 } = this.time

      const arr = value.split(':')

      // const minFromData = this.editedItem.times[index].data[index1][key]
      const min = parseInt(arr[0]) * 60 + parseInt(arr[1])

      const { data } = this.editedItem.times[index]

      data[index1][key] = min

      await this.checkTime(index)
    },
    async checkTime(index) {
      const { data, error } = this.editedItem.times[index]

      error.time = false
      error.overlap = false
      for (let i = 0; i < data.length; i++) {
        const dataBe = data[i - 1]
        const dataAf = data[i + 1]

        if (data[i].start >= data[i].end && dataAf) {
          error.time = true
        } else {
          if (data[i].end !== 0 && data[i].end <= data[i].start) {
            error.time = true
          }
        }

        if (dataBe) {
          if (data[i].start <= dataBe.start || data[i].start <= dataBe.end) {
            error.overlap = true
          }
        }

        if (dataAf) {
          if (i === data.length - 2 && dataAf.end !== 0) {
            if (data[i].end >= dataAf.start || data[i].end >= dataAf.end) {
              error.overlap = true
            }
          }
        }
      }
    },

    closeDialog() {
      this.$emit('close', null)
    },
    save() {
      let check_error_time = false
      for (const key in this.editedItem.times) {
        if (Object.hasOwnProperty.call(this.editedItem.times, key)) {
          const element = this.editedItem.times[key]
          check_error_time =
            element.error.time || element.error.overlap ? true : false
        }
        if (check_error_time) break
      }

      const re = /^[a-zA-Z0-9_]+$/i
      if (this.editedItem.fieldGroup) {
        if (
          this.editedItem.fieldGroup.length < 1 ||
          this.editedItem.fieldGroup.length > 50
        ) {
          this.errorMessage.text = 'Field group must be 1-50 characters'
          return false
        } else if (!re.test(this.editedItem.fieldGroup)) {
          this.errorMessage.text =
            'Field group must be alphanumeric ( A-Z, a-z, 0-9, _ )'
          return false
        }
      }

      if (!this.editedItem.name) {
        this.errorMessage.text = 'Campaign name is required'
        return false
      } else if (
        this.editedItem.name.length < 1 ||
        this.editedItem.name.length > 50
      ) {
        this.errorMessage.text = 'Campaign name must be 1-50 characters'
        return false
      } else if (!this.editedItem.flowId) {
        this.errorMessage.text = 'Flow is required'
        return false
      } else if (check_error_time) {
        this.errorMessage.text =
          'Unable to save these response hours. Please make sure none of your work periods overlap.'
        return false
      } else if (this.editedItem.preCallApi) {
        if (!this.editedItem.url) {
          this.errorMessage.text = 'URL is required'
          return false
        }
        for (const obj of this.editedItem.headers) {
          if (!obj.key) {
            this.errorMessage.text = 'Key is required'
            return false
          }
        }
      }

      if (this.editedItem.postCallApi) {
        if (!this.editedItem.postCallApiData.url) {
          this.errorMessage.text = 'URL is required'
          return false
        }
        for (const obj of this.editedItem.postCallApiData.headers) {
          if (!obj.key) {
            this.errorMessage.text = 'Key is required'
            return false
          }
        }
      }

      if (this.editedItem.isCustomCaller) {
        if (this.editedItem.customCallerArr.length === 0) {
          this.errorMessage.text = 'Select at least 1 number'
          return false
        }
      }

      this.editedItem.retryCount -= 1

      this.$emit('save', null)
    },
    goToFlow(flowId) {
      const routeData = this.$router.resolve({
        path: `/flows/builder/${flowId}`
      })
      window.open(routeData.href, '_blank')
    },
    goToField() {
      const routeData = this.$router.resolve({
        path: '/settings/fields'
      })
      window.open(routeData.href, '_blank')
    },
    goToHoliday() {
      const routeData = this.$router.resolve({
        path: '/settings/holidays'
      })
      window.open(routeData.href, '_blank')
    },
    payloadKeyClick(event) {
      this.indexPayload.index = event.target.getAttribute('data-index')
    },
    async payloadKeyChange() {
      this.errorMessage.text = ''

      this.errorPayload.status = false
      this.errorPayload.text = ''

      await this.checkPayloadKey()
    },
    async checkPayloadKey() {
      this.errorPayload.status = false
      this.errorPayload.text = ''

      const { payload } = this.editedItem

      const check = []
      for (let i = 0; i < payload.length; i++) {
        if (check.indexOf(payload[i].key) !== -1) {
          payload[i].error.status = true
          payload[i].error.text = payload[i].key

          if (!this.errorPayload.status) {
            this.errorPayload.text = payload[i].key
          }
          this.errorPayload.status = true
        } else {
          payload[i].error.status = false
          payload[i].error.text = ''
        }

        if (payload[i].key !== '') {
          check.push(payload[i].key)
        }
      }
    },
    addPayloadClick() {
      this.editedItem.payload.push({
        key: '',
        value: '',
        error: {
          status: false,
          text: ''
        }
      })
    },
    async deletePayloadClick(index) {
      this.editedItem.payload.splice(index, 1)

      await this.checkPayloadKey()
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__text {
  height: 460px;
}

.retry-with-priority {
  margin: 0 !important;
  padding: 0 !important;
}

.time1 {
  min-width: 35px;
}
.time2 {
  width: 103px;
}
.time3 {
  width: 108px;
}
.time4 {
  width: 101px;
}
.time5 {
  width: 82px;
}
.time6 {
  width: 50px;
}
.day1 {
  min-width: 52px;
}
.time-active {
  margin: auto;
  height: 15px;
  width: 18.2px;
  background: $primary;
}
.time-inactive {
  margin: auto;
  height: 15px;
  width: 18.2px;
  background: #d2d2d2;
}
input:focus {
  outline: none;
}

#upload-csv {
  cursor: pointer;
  color: $primary;
  text-decoration: underline;
}
.icon-add-payload {
  cursor: pointer;
  margin-left: 62px;
}

.td-text-phone_number {
  max-width: 90px !important;
  word-break: break-word;
}
.td-text-payload {
  max-width: 190px !important;
  word-break: break-word;
}
.text-payload {
  padding-left: 62px;
}

.slider-text {
  width: 30px;
}

::v-deep .v-input__icon.v-input__icon--clear {
  width: 16px;
  min-width: 16px;
  height: 16px;
  .v-icon.v-icon {
    font-size: 16px !important;
    margin-top: 18px !important;
  }
}

::v-deep .v-chip.v-size--default {
  font-size: 12px;
  height: 22px;
}
</style>
